import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoClose16 } from '@onefootprint/icons';
import * as RadixDialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../../icon-button';
import { HEADER_HEIGHT } from '../dialog.constants';
type ActionConfig = {
  component: Icon;
  ariaLabel: string;
  onClick: () => void;
};
interface HeaderProps {
  title: string;
  onClose?: () => void;
  icon?: {
    component: Icon;
    ariaLabel: string;
    onClick?: () => void;
  };
  action?: ActionConfig;
  secondaryAction?: ActionConfig;
}
const DialogHeader = forwardRef<HTMLDivElement, HeaderProps>((t0, ref) => {
  const $ = _c(24);
  const {
    title,
    onClose,
    icon,
    action,
    secondaryAction
  } = t0;
  const {
    t
  } = useTranslation("ui");
  const IconComponent = icon?.component ?? IcoClose16;
  let t1;
  if ($[0] !== icon?.ariaLabel || $[1] !== t) {
    t1 = icon?.ariaLabel ?? t(_temp);
    $[0] = icon?.ariaLabel;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const iconAriaLabel = t1;
  const iconOnClick = icon?.onClick ?? onClose;
  const ActionIcon = action?.component;
  const SecondaryActionIcon = secondaryAction?.component;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: `${HEADER_HEIGHT}px`
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== IconComponent || $[5] !== iconAriaLabel || $[6] !== iconOnClick) {
    t3 = iconOnClick ? <IconButton aria-label={iconAriaLabel} onClick={iconOnClick} icon={IconComponent} size="tiny" /> : <span />;
    $[4] = IconComponent;
    $[5] = iconAriaLabel;
    $[6] = iconOnClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <RadixDialog.Title asChild={true}><h3 className="text-center truncate text-label-2 text-primary">{title}</h3></RadixDialog.Title>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== SecondaryActionIcon || $[11] !== secondaryAction) {
    t5 = SecondaryActionIcon && secondaryAction && <IconButton aria-label={secondaryAction.ariaLabel} onClick={secondaryAction.onClick} icon={SecondaryActionIcon} size="tiny" />;
    $[10] = SecondaryActionIcon;
    $[11] = secondaryAction;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== ActionIcon || $[14] !== action) {
    t6 = ActionIcon && action && <IconButton aria-label={action.ariaLabel} onClick={action.onClick} icon={ActionIcon} size="tiny" />;
    $[13] = ActionIcon;
    $[14] = action;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="flex items-center gap-1 min-w-6 justify-end">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== ref || $[20] !== t3 || $[21] !== t4 || $[22] !== t7) {
    t8 = <header className="grid grid-cols-[24px_1fr_auto] items-center sticky px-2 top-0 z-10 bg-primary border-b border-tertiary border-solid rounded-t shrink-0" style={t2} ref={ref}>{t3}{t4}{t7}</header>;
    $[19] = ref;
    $[20] = t3;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
});
DialogHeader.displayName = 'DialogHeader';
export default DialogHeader;
function _temp($) {
  return $.components.dialog["header-icon"]["aria-label-default"];
}